<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import General from '@/services/General';
import ExcelJS from "exceljs";
export default {
    components: { Layout, PageHeader},
    page: {
        title: "Application Marketing Popup",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Marketing Popup Participation Details",
            items: [
                {
                    text: "Marketing Popup",
                    href: "/app/popup",
                },
                {
                    text: "Marketing Popup Participation Details",
                    active: true,
                },
            ],
            isBusy: false,
            error: null,
            showLoader:false,
            showLoader_init:false,
            showModal: false,
            modalData: {},
            link_id: null,
            tableData: [],
            newData:[],
            totalPages: 0,
            totalItems:0,
            currentPage: 1,
            popupName:'',
            popupTitle:'',
            popupBottomText:'',

            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "pdate_formatted",
            sortDesc: true,
            fields: [
                {
                    key: "first_name",
                    label: "Full Name",
                    sortable: true,
                },
                {
                    key: "email",
                    label: "Email",
                    sortable: true,
                },
                {
                    key: "fav_club",
                    label: "Favourite Club",
                    sortable: true,
                },
                {

                    key: "timestamp",
                    label: "Timestamp",
                    sortable: true,
                },

            ],
        };
    },
    async created() {
        await this.getParticipationUsers()
        await  this.getPopupData()
    },
    watch: {
        perPage(newSize) {
            this.currentPage = 1;
            this.getParticipationUsers(1, newSize);
        }
    },
    methods: {

        async getParticipationUsers(page=1,limit=10) {
            try {
                this.isBusy= true
                const popup_id = this.$route.params.id;
                const response = await General.getParticipationUsers(popup_id,page, limit)
                this.tableData = response.data.data.participants
                this.totalItems =  response.data.data.total_items
                this.totalPages = response.data.data.total_pages
                this.isBusy= false

            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "";
                this.tableData = []
                this.totalItems = 0
                this.totalPages = 0
                this.isBusy= false
            }
        },

        async getPopupData() {
            try {

                const popup_id = this.$route.params.id;
                console.log(popup_id,'id')
                const data = {
                    popup_id: popup_id,
                    type: 'all'
                }
                // const qs = new URLSearchParams(data).toString();
                const response = await General.getHypePopUpById(data)
                this.popupName = response.data.popups[0].name;
                this.popupTitle = response.data.popups[0].title;
                this.popupBottomText = response.data.popups[0].bottom_text;

            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "";

            }
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async exportToExcel() {
            try {
                alert('Generating report. Please wait...')
                const popup_id = this.$route.params.id;
                const response = await General.getParticipationUsers(popup_id,1, 10000)
                this.newData = response.data.data.participants
                if (Array.isArray(this.newData)) {
                    const ExcelJS = require('exceljs'); // Import ExcelJS
                    const workbook = new ExcelJS.Workbook();
                    const worksheet = workbook.addWorksheet('HypePopupUserParticipations');

                    // Define column headers and their corresponding column letters
                    const columnHeaders = [
                        { key: 'first_name', header: 'First Name', width: 80 },
                        { key: 'last_name', header: 'Last Name', width: 80 },
                        { key: 'email', header: 'Customer Email', width: 80 },
                        { key: 'fav_club', header: 'Favourite Club', width: 80 },
                        { key: 'timestamp', header: 'Timestamp', width: 80 },
                    ];

                    // Add header row
                    worksheet.addRow(columnHeaders.map(column => column.header));
                    worksheet.getRow(1).font = { bold: true };

                    // Set column letters for each header
                    columnHeaders.forEach((column, index) => {
                        const cell = worksheet.getCell(String.fromCharCode(65 + index) + '1'); // A1, B1, C1, ...
                        cell.width = column.width;
                    });

                    // Add data rows from the API response
                    this.newData.forEach(item => {
                        const rowData = columnHeaders.map(column => item[column.key]);
                        worksheet.addRow(rowData);
                    });

                    // Create a blob from the Excel workbook
                    const buffer = await workbook.xlsx.writeBuffer();

                    // Create a Blob object and initiate download
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'HypePopupUserParticipations.xlsx';
                    link.click();

                } else {
                    alert('No data available for generating the report.');
                }

            } catch (error) {
                alert('An error occurred while fetching data from the API.');
            }
        },
},

    middleware: "authentication",
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-center-start" style="gap: 20px;">
                            <p v-if="popupName" class="font-size-18"><b>Name:</b> {{popupName}} ( Total Users:{{totalItems}} )</p>
<!--                            <p v-if="popupTitle" class="font-size-18"><b>:</b> {{popupTitle}}</p>-->

                        </div>
                        <div class="row mt-4" style="height: 70px;">
                            <div class="col-sm-12 col-md-6 mb-5">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center me-5">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm"
                                                       :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                </div>

                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input v-model="filter" type="search" placeholder="Search..."
                                                      class="form-control form-control-sm ms-2"></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="table-responsive mb-0">
                                    <div class="col-md-12 d-flex justify-content-end">
                                        <b-button
                                                style="margin-bottom: 10px"
                                                class="float-end"
                                                variant="success"
                                                title="Export to Excel"
                                                @click="exportToExcel()"
                                        >Export to Excel</b-button>
                                    </div>
                                    <b-table
                                            :busy="isBusy"
                                            :items="tableData"
                                            :fields="fields"
                                            responsive="sm"
                                            :filter="filter"
                                            :filter-included-fields="filterOn"
                                            show-empty
                                            empty-text="No Data Found"
                                    >
                                        <template v-slot:cell(first_name)="data">
                                            {{data.item.first_name}} {{data.item.last_name  }}
                                        </template>
                                        <template v-slot:cell(email)="data">
                                            <a :href="`/customers/profile/${data.item.customer_id}`">{{data.item.email}}</a>
                                        </template>
                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>

                                    </b-table>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalItems"
                                                :per-page="perPage"
                                                @change="page => getParticipationUsers(page, perPage)"
                                                align="right"
                                                class="my-2"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--        &lt;!&ndash; MODALS &ndash;&gt;-->
        <!--        <modalAddHypePopUp @onRefresh="getHypePopUp"></modalAddHypePopUp>-->
        <!--        <modalEditHypePopUp @onRefresh="getHypePopUp" :popupsData="modalData"></modalEditHypePopUp>-->
        <!--        <modalHypePopUpPhotos @onRefresh="getHypePopUp"  :popupsData="modalData"></modalHypePopUpPhotos>-->
        <!--        &lt;!&ndash; /MODALS &ndash;&gt;-->
    </Layout>
</template>
